import CryptoCurrencyList from ".";

export const cryptoCurrencyRoutes = () => [
  {
    path: "/admin/crpto-list",
    component: CryptoCurrencyList,
    layout: "admin",
    routeType: "admin",
    title: "Crypto Management",
  },
];
